import { Injectable } from '@angular/core';
import { WebService } from '../web/web.service';
import {
  Filters,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { Observable } from 'rxjs';
import { ESRS } from './esrs.service';

@Injectable({
  providedIn: 'root',
})
export class ESRSWebService {
  private readonly nomeWs = 'temi';

  constructor(private readonly webService: WebService) {}

  /**
   * Funzione per selezionare le righe da far vedere nella grid
   * Anche se dovrebbe essere una get, viene fatto il post per passarli dei parametri di visualizzazione
   * @param page pagina
   * @param pageSize record per pagina
   * @param ricerca risultato per ricerca
   * @param filters valori da filtrare
   * @param sortBy sort asc desc
   * @returns lista di righe
   */
  public get(
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ): Observable<any> {
    return this.webService.doPost('/api/v1/' + this.nomeWs + '/list', {
      page,
      pageSize,
      ricerca,
      filters,
      sortBy,
    });
  }

  /**
   * Funzione per eliminare una riga da una lista
   * @param idESRS id della riga da eliminare
   * @returns
   */
  public delete(idESRS: any): Observable<any> {
    return this.webService.doDelete('/api/v1/' + this.nomeWs + '/delete', { id: idESRS });
  }

  public postEsrs(esrs: ESRS) {
    return this.webService.doPost('/api/v1/' + this.nomeWs, { ...esrs });
  }

  public putEsrs(id: string, esrs: ESRS): Observable<any> {
    return this.webService.doPut('/api/v1/' + this.nomeWs + '/update', esrs, {
      id,
    });
  }

  public putEsrsTematica(idEsrs: string, idTematica: string, esrs: ESRS): Observable<any> {
    return this.webService.doPut(
      '/api/v1/' +
        this.nomeWs +
        '/' +
        idEsrs +
        '/tematica/' +
        idTematica +
        '/selection-for-tematica',
      { ...esrs },
    );
  }

  /**
   * Recuepra un esrs per id
   * @param idEsrs
   * @returns
   */
  public getEsrsById(idEsrs: string, idTematica: string): Observable<any> {
    return this.webService.doGet(
      '/api/v1/' +
        this.nomeWs +
        '/' +
        idEsrs +
        '/tematica/' +
        idTematica +
        '/selection-for-tematica',
      {},
    );
  }
}
